import { PlanUnitMix } from 'components/types';

import { CreateScenarioPayload } from 'RestAPIs/scenario';

import { ScenarioForm } from './AddEditScenarioDialog';

export const formatScenarioFormDataForSave = (
  data: ScenarioForm,
  scenarioToCopyId: number | null
): CreateScenarioPayload => {
  const costCenters = data.costCenters.filter(
    (val) => !!val?.id
  ) as PlanUnitMix[];

  return {
    ...data,
    scenarioToCopyId,
    costCenters: costCenters.map(({ id }) => ({ id }))
  } as CreateScenarioPayload;
};
